

    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'Hamburger',
        props: {
            isOpen: {
                type: Boolean, default: false
            }
        }
    })

